import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, Settings, BookOpen, LogOut, Headset } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LogoMark } from "@/components/ui-kit";

const NAV = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/admin/leads", icon: Users, label: "Leads (CRM)" },
  { to: "/admin/cms", icon: Settings, label: "CMS" },
  { to: "/admin/knowledge", icon: BookOpen, label: "Knowledge Base" },
  { to: "/admin/support", icon: Headset, label: "Support" },
];

export default function AdminLayout({ children, title }) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#060D1F] flex flex-col md:flex-row" data-testid="admin-layout">
      <aside className="md:w-60 glass md:min-h-screen border-b md:border-b-0 md:border-r border-white/10 p-5 flex md:flex-col gap-2 md:gap-1 items-center md:items-stretch overflow-x-auto">
        <div className="hidden md:flex items-center gap-2.5 px-2 py-4 mb-4 group">
          <LogoMark className="w-9 h-9" />
          <span className="text-white font-display">Admin</span>
        </div>
        {NAV.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.end}
            data-testid={`admin-nav-${n.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm whitespace-nowrap transition-colors duration-300 ${
                isActive ? "bg-[#D4AF37]/15 text-[#D4AF37]" : "text-slate-400 hover:text-white hover:bg-white/5"
              }`
            }
          >
            <n.icon className="w-4 h-4" /> {n.label}
          </NavLink>
        ))}
        <button
          data-testid="admin-logout-button"
          onClick={async () => { await logout(); navigate("/admin/login"); }}
          className="flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm text-slate-400 transition-colors duration-300 hover:text-red-400 md:mt-auto"
        >
          <LogOut className="w-4 h-4" /> Log out
        </button>
      </aside>
      <main className="flex-1 p-5 sm:p-8 lg:p-10 overflow-x-hidden">
        <h1 className="text-2xl sm:text-3xl text-white tracking-tight mb-8" data-testid="admin-page-title">{title}</h1>
        {children}
      </main>
    </div>
  );
}
